'use client'

import { FC } from 'react'
import useI18n from 'Hooks/useI18n'
import CountdownTimer from './components/CountdownTimer'

const HalloweenBannerCard: FC = () => {
  const { t } = useI18n()

  return (
    <div
      className="relative flex h-full w-full flex-col items-center justify-between bg-cover bg-center px-4 pb-[42px] pt-5"
      style={{
        backgroundImage: 'url(/activity/bg_halloween.png)',
      }}
    >
      {/* 上方内容区域 */}
      <div className="flex flex-1 flex-col items-center justify-center">
        {/* 倒计时 */}
        <CountdownTimer deadline={undefined} />
      </div>

      {/* 下方内容区域 */}
      <div className="flex w-full flex-col items-center gap-3">
        {/* 主标题区 */}
        <div className="flex flex-col items-center justify-center px-2 text-center">
          <p className="mb-2 text-center text-[13px] font-normal leading-[1.33em] text-white/80">
            {t('Create characters with tag Halloween 2025 to join!')}
          </p>
        </div>

        {/* 时间信息 */}
        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-center text-[13px] font-normal leading-[1.33em] text-white/80">
            {t('Time：10/22-10/31')}
          </p>
        </div>

        {/* 详情文案 */}
        <div className="flex flex-col items-center justify-center text-center">
          <p className="text-center text-[10px] font-normal leading-[1.6em] text-white/80">
            {t('See details in your notifications.')}
          </p>
        </div>

        {/* 查看按钮 */}
        <div className="w-full">
          <button className="h-[26px] w-full rounded-full bg-white/20 text-[13px] font-medium leading-[26px] text-white hover:bg-white/30">
            {t('View')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default HalloweenBannerCard
